import BannerWidget from './BannerWidget';
import { Config } from './types';
import BannerWidgetControl from './BannerWidgetControl';
import {
  defaultBackgroundImageData,
  defaultBorderData,
  widgetTypes,
} from 'builder/util/constants';

export default {
  type: widgetTypes.Banner,
  displayName: 'Banner',
  icon: 'cards-blank',
  initialConfig: {
    ...defaultBackgroundImageData,
    borderData: {
      ...defaultBorderData.borderData,
      radius: 5,
    },
    paddingData: {
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
    },
    width: 1275,
    height: 100,
    xLocation: 10,
    yLocation: 10,
    uniqueId: 'banner345',
    lineColor: '#828485',
    showonAllPage: false,
    browserCondition: false,
    browserList: '',
    backgroundData: { style: 'Color', color: '#EEF4FF' },
    enableFullScreen: false,
    visible: true,
    placement: 'Below Header (Inline)',
    allowDismiss: false,
  },
  components: {
    render: BannerWidget,
    control: BannerWidgetControl,
  },
  copyable: true,
} as HorizonWidgetDefinition<Config>;
